import React, { Component } from 'react';
import {Link, withRouter} from 'react-router-dom';
import {Toast,Flex, Badge, Button, Modal} from 'antd-mobile';
import Bubble from './components/bubble'
import Mask from './components/mask'
import './create.css'
import auth from '../../utils/auth'
import web from '../../utils/native'
import {ISDEMO, FARM_FLAG} from '../../cache';

class Strand extends Component {
  constructor (props) {
    super(props);
    this.state = {
      coop: false,
      path: '',
      isFirst: false,  // 用户是否首次进入，若首次进入需要创建猪场，则为true，否则为false
      cooperation: true, // 是否合作
      tooltips: [
        {
          message: '首先要有一个猪场，让我们一起来创建您的猪场吧！',
          position: {
            top: 0
          },
          visible: true
        }
      ],
      menus: [
        {
          title: '猪场管理',
          type: 'farm',
          link: '/farm_list'
        },
        {
          title: '栋舍管理',
          type: 'loc',
          link: '/loc_list'
        },
        {
          title: '批次维护',
          type: 'batch',
          link: '/batch_list'
        },
        {
          title: '员工管理',
          type: 'staff',
          link: '/staff_list'

        },
        {
          title: '商品管理',
          type: 'product',
          link: '/product_list'
        },
        {
          title: '猪只管理',
          type: 'swine',
          link: '/swine_list'
        },
        {
          title: '我要合作',
          type: 'cooperate',
          link: '/cooperate'
        }
      ]
    }
  }
  style = (index) => {
    return {
      left: (index  % 4) * 25 + 'vw',
      top: Math.floor((index+1 / 4)) * 2 + 'rem'
    }
  };
  getClassName = (index) => {
    const {isFirst} = this.state;
    let className = 'link-wrap';
    if (isFirst && index === 0) {
      className = 'link-wrap topShow touch'
    }
    return className
  };
  test = (data) => {
    console.log('test', data)
  };
  UNSAFE_componentWillMount123456() {
    // ios提醒用户想办法更新app 。因为2020-7-9上线版本无法给ios 发布最新版。
    if(typeof window.android === 'undefined') {
      // ios 设备 且 没有传来 FARM_FLAG
      Modal.alert('更新应用', '创建猪场需要更新应用,是否继续?', [
        {
          text: '退出',
          onPress: () => {
            web.callNativeModal('backHome')
          }
          },
        {
          text: '确定',
          onPress: () => {
            window.location.replace('https://testflight.apple.com/join/oWmoYWbj');
            // window.open('https://testflight.apple.com/join/oWmoYWbj');
          }
        }
      ])
    }
    return false
  }
  async componentDidMount () {
    // 是否绑定的是演示农场
    let isFirst = auth.getCookie('farm_flag') === 'false';
    // 是否合作
    const coop = auth.getCookie('coop')==='true';
    //当未合作 未绑定
    this.setState({
      coop,
      isFirst,
      path: auth.readCookie('path') || '/createfarm/farm_add'
    });
    auth.setCookie('ISFIRST', isFirst);
    auth.setToCookie('coop', coop);
    auth.getPosition();
    // 查询当前登陆用户的信息，如果用户没有录入，则作为默认员工录入
    let userInfoRes = await auth.getUserInfo();
    if (userInfoRes.status === 200 && userInfoRes.data.error === 0) {
      const {uid_id, realname,tel_mobile} = userInfoRes.data.data.cp_user_info;
      auth.setCookie('userInfo', {
        contact: true,
        newStaff: false,
        id: uid_id,
        username: realname,
        phoneNum: tel_mobile,
        type: [
          {'label': '养殖场老板', 'value': '1', 'checked': true},
          {'label': '技术员', 'value': '37', 'checked': true},
          {'label': '业务员', 'value': '36', 'checked': true}
        ]
      })
    }
  }

  renderMenu = () => {
    const {isFirst,path} = this.state;
    return <Flex wrap="wrap">
      {
        this.state.menus.map((o,index) => {
          return <div className={this.getClassName(index)}
              style={this.style(index)}
              key={index}
                 >
            <Link to={
              {
                pathname: isFirst ? path : o.link,
                state:{
                  isFirst: isFirst,
                  current: o.type
                }
              }
            }
                className="link"
            >
              <div className="linkImg"
                  style={{
                     backgroundImage: `url(${require('../../assets/image/' +
                       o.type + '.png')})`
                   }}
              />
              <div className="linkTitle">{o.title}</div>
              {
                o.type === 'cooperate' ?
                <Badge text="我要合作"
                    hot
                    style={{backgroundColor: '#FF3B30',marginTop: -85, marginLeft: 60, transform: 'scale(0.9)'}}
                />
                : null
              }
            </Link>
          </div>
        })
      }
    </Flex>
  };
  render() {
    const {isFirst,path} = this.state;
    return (
      <React.Fragment>
        {/*{coop? '合作': '未合作'}--*/}
        {/*{auth.getBind() ? '绑定': '未绑定'}---*/}
        {/*{isFirst ? '是第一次': '不是'}*/}
        {this.renderMenu()}
        {
          isFirst && <div>
            <Mask  visible={isFirst}>
              {
                this.state.tooltips.map((item, index) => {
                  return <Bubble {...item.position}
                      key={index}
                      visible={item.visible.toString()}
                         >
                    <div>
                      <div className={'line'}
                          style={{
                        height: 244,
                        width: 112,
                        marginTop: 50,
                        marginLeft: 'calc(-40px + 23vw)',
                        backgroundImage: `url(${require('../../assets/image/setting-line.png')})`
                      }}
                      />
                        {item.message}
                      {/*<br/>*/}
                      {/*{FARM_ORG}---{ORG_CODE}*/}
                      {/*<br/>*/}
                      {/*演示农场{ISDEMO + ''}---- FARM_FLAG:{FARM_FLAG + ''} <br/>*/}
                      {/*开启定位了{LOCATION + ''} GPS {GPS + ''}*/}
                        <Flex style={{margin: '15px -30px'}}>
                          <Flex.Item>
                            <Button onClick={() => {
                              web.callNativeModal('backHome')
                            }}
                            >退出设定</Button>
                          </Flex.Item>
                          <Flex.Item>
                            <Button type={'primary'}
                                onClick={() => {
                                      this.props.history.push({
                                        pathname: path,
                                        state: {
                                          isFirst
                                        }
                                      })
                                    }}
                            >创建猪场</Button>
                          </Flex.Item>
                        </Flex>
                    </div>
                    <div style={{display: 'none'}}>
                      <span style={{padding: '5px 0',background: '#faa'}} onClick={() => {
                        auth.setToCookie('farm_flag','true')
                      }
                      }>设定isdemo=true</span>
                      <span style={{padding: '5px 0',background: '#fe0'}} onClick={() => {
                        auth.setToCookie('farm_flag','false')
                      }
                      }>设定farm_flag= false</span>
                      <br/>
                      <span onClick={() => {
                        Toast.info('is demo ===' + auth.getCookie('farm_flag'))
                      }
                      }>读取farm_flag</span>
                      <span onClick={() => {
                        Toast.info('coop ===' + auth.getCookie('coop'))
                      }
                      }>读取coop</span>
                    </div>
                  </Bubble>
                })
              }
            </Mask>
          </div>
        }
      </React.Fragment>


    )
  }
}
export default withRouter(Strand)
